var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGame(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 162,
    viewBox: "0 0 204 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_16_247)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.503 50.4083C136.257 23.717 111.783 42.2865 111.783 42.2865C110.196 43.486 107.27 44.4723 105.281 44.4769L98.7256 44.4815C96.737 44.4838 93.8103 43.4975 92.2254 42.2979C92.2254 42.2979 67.7497 23.7238 51.5014 50.4152C35.2577 77.0974 41.8038 106.156 41.8038 106.156C42.9506 113.271 46.7306 118.019 53.8639 117.422C60.9765 116.828 76.4152 98.261 76.4152 98.261C77.6905 96.7312 80.3626 95.4811 82.3466 95.4811L121.646 95.4742C123.633 95.4742 126.302 96.7243 127.575 98.2542C127.575 98.2542 143.016 116.821 150.14 117.415C157.265 118.012 161.054 113.259 162.194 106.149C162.191 106.149 168.749 77.0951 152.503 50.4083ZM87.2321 72.1339H78.8052V80.2558C78.8052 80.2558 77.0207 81.6182 74.2591 81.5838C71.5022 81.5425 70.2544 80.0975 70.2544 80.0975V72.1362H62.2954C62.2954 72.1362 61.3022 71.1178 61.0362 68.4365C60.7747 65.7552 62.1348 63.5877 62.1348 63.5877H70.564V55.1608C70.564 55.1608 72.2981 54.2319 74.7913 54.303C77.2868 54.3809 79.1148 55.3191 79.1148 55.3191L79.0804 63.5854H87.0394C87.0394 63.5854 88.4294 65.3699 88.5441 67.5259C88.6588 69.6843 87.2321 72.1339 87.2321 72.1339ZM125.885 81.3911C122.194 81.3911 119.22 78.4071 119.22 74.7212C119.22 71.0284 122.194 68.0512 125.885 68.0512C129.559 68.0512 132.557 71.0284 132.557 74.7212C132.557 78.4094 129.559 81.3911 125.885 81.3911ZM125.885 63.0395C122.194 63.0395 119.22 60.0578 119.22 56.3718C119.22 52.6791 122.194 49.7019 125.885 49.7019C129.559 49.7019 132.557 52.6791 132.557 56.3718C132.557 60.0601 129.559 63.0395 125.885 63.0395ZM142.496 72.8908C138.805 72.8908 135.83 69.9091 135.83 66.2208C135.83 62.5303 138.805 59.5509 142.496 59.5509C146.17 59.5509 149.168 62.5303 149.168 66.2208C149.168 69.9091 146.17 72.8908 142.496 72.8908Z",
    fill: "url(#paint0_radial_16_247)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_16_247)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.232 72.1339H78.8051V80.2558C78.8051 80.2558 77.0206 81.6182 74.259 81.5838C71.5021 81.5425 70.2543 80.0975 70.2543 80.0975V72.1362H62.2953C62.2953 72.1362 61.3021 71.1178 61.0361 68.4365C60.7746 65.7552 62.1347 63.5877 62.1347 63.5877H70.564V55.1608C70.564 55.1608 72.298 54.2319 74.7912 54.303C77.2867 54.3809 79.1147 55.3191 79.1147 55.3191L79.0803 63.5854H87.0393C87.0393 63.5854 88.4293 65.3699 88.544 67.5259C88.6587 69.6843 87.232 72.1339 87.232 72.1339Z",
    fill: "#BCBCBC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_16_247)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.885 81.3912C122.194 81.3912 119.219 78.4072 119.219 74.7212C119.219 71.0284 122.194 68.0513 125.885 68.0513C129.559 68.0513 132.557 71.0284 132.557 74.7212C132.557 78.4095 129.559 81.3912 125.885 81.3912Z",
    fill: "url(#paint1_linear_16_247)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_16_247)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.885 63.0396C122.194 63.0396 119.219 60.0578 119.219 56.3719C119.219 52.6791 122.194 49.7019 125.885 49.7019C129.559 49.7019 132.557 52.6791 132.557 56.3719C132.557 60.0601 129.559 63.0396 125.885 63.0396Z",
    fill: "url(#paint2_linear_16_247)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_16_247)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.495 72.8907C138.805 72.8907 135.83 69.909 135.83 66.2208C135.83 62.5303 138.805 59.5508 142.495 59.5508C146.17 59.5508 149.168 62.5303 149.168 66.2208C149.168 69.909 146.17 72.8907 142.495 72.8907Z",
    fill: "url(#paint3_linear_16_247)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_16_247",
    x: 0.5,
    y: 0,
    width: 203,
    height: 161.473,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16_247"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16_247",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_16_247",
    x: 57.0027,
    y: 54.2991,
    width: 35.5479,
    height: 35.2854,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16_247"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16_247",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_16_247",
    x: 115.219,
    y: 68.0513,
    width: 21.3376,
    height: 21.3398,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16_247"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16_247",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_16_247",
    x: 115.219,
    y: 49.7019,
    width: 21.3376,
    height: 21.3376,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16_247"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16_247",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_16_247",
    x: 131.83,
    y: 59.5508,
    width: 21.3376,
    height: 21.3398,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16_247"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16_247",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_16_247",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(92.8038 44.5492) rotate(90) scale(97.8556 147.733)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111111",
    stopOpacity: 0.67
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16_247",
    x1: 116.634,
    y1: 68.0704,
    x2: 128.784,
    y2: 77.8252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#96DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.923907,
    stopColor: "#02A3F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_16_247",
    x1: 116.634,
    y1: 49.721,
    x2: 128.783,
    y2: 59.4762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7953"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.923907,
    stopColor: "#F25123"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_16_247",
    x1: 133.245,
    y1: 59.5699,
    x2: 145.395,
    y2: 69.3247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBFD5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.923907,
    stopColor: "#7FBA00"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGame);
export default __webpack_public_path__ + "static/media/Game.7193c9567e346febe5171f3318e9d189.svg";
export { ForwardRef as ReactComponent };